import React from 'react';
import {submit} from 'redux-form';

import {default as Modal, withModal} from 'components/Modal';
import Button from 'components/Button';
import {
  MODALS,
  fetchAllTeams,
  fetchTeamDetail,
  fetchMyTeams
} from 'ducks/teams';
import {storeDataInModal} from 'ducks/modals';

import {EditTeamDetailsForm} from './components';

import './styles.css';

class EditTeamDetailsModal extends React.Component<any> {
  triggerSubmit = () => {
    this.props.submit('editTeamDetails');
  };

  modalExtraActions = () => {
    return [
      ...this.props.closeModalExtraActions,
      () =>
        this.props.fetchTeamDetail({teamId: this.props.data.teamId}, [
          data =>
            this.props.storeDataInModal({
              modalName: MODALS.TEAM_DETAILS,
              data: {team: data}
            })
        ]),
      () => this.props.fetchAllTeams(),
      () => this.props.fetchMyTeams()
    ];
  };

  render() {
    return (
      <Modal
        className="EditTeamDetailsModal"
        type={Modal.EXTRA_SMALL}
        show={true}
        onClose={this.props.closeModal}>
        <Modal.Header heading="Edit Team Details" />
        <Modal.Body>
          <EditTeamDetailsForm
            teamId={this.props.data.teamId}
            modalExtraActions={this.modalExtraActions()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button blue onClick={this.triggerSubmit}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = {
  submit,
  fetchAllTeams,
  fetchTeamDetail,
  storeDataInModal,
  fetchMyTeams
};

export default withModal(
  MODALS.EDIT_TEAM_DETAILS,
  mapStateToProps,
  mapDispatchToProps
)(EditTeamDetailsModal);
